<template>
     <v-app>
          <home-app-bar></home-app-bar>
          <home-view />

          <home-footer />
     </v-app>
</template>

<script>
export default {
     name: 'HomeLayout',

     components: {
          HomeAppBar: () => import('@/layouts/home/AppBar'),
          HomeAppBarCentered: () => import('@/layouts/home/AppBarCentered'),
          HomeAppBarDropDownMenu: () =>
               import('@/layouts/home/AppBarDropDownMenu'),
          HomeFooter: () => import('@/layouts/home/FooterSimple'),
          HomeView: () => import('@/layouts/home/View'),
     },
}
</script>
